import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import EditIcon from '@/components/molecules/EditIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePositionsTableCell',
  props: {
  fieldName: {
    type: String,
    default: ''
  },
  isNarrow: Boolean,
  isReduced: Boolean,
  isAttachmentPdf: {
    type: Boolean,
    default: false
  }
},
  emits: ['view', 'download', 'onClickOfFileName'],
  setup(__props, { emit }) {

const props = __props;



const areButtonsVisible = computed(() => (props.isNarrow && !props.isReduced ? props.fieldName === 'created' : props.fieldName === 'filename'));
const { canInvoiceBeEdited, isAttachmentRequestRunning } = useInvoice();


const canViewAttachment = computed(() => props.fieldName === 'filename' && !isAttachmentRequestRunning.value && props.isAttachmentPdf);

function onClickOfField() {
  if (canViewAttachment.value) emit('onClickOfFileName');
}

const templateColumns = computed(() => {
  if (!areButtonsVisible.value) return 'auto';

  const isDeleteButtonVisible = !props.isReduced && canInvoiceBeEdited.value;

  if (isDeleteButtonVisible && props.isAttachmentPdf) return '1fr auto auto auto'; // Three buttons are displayed
  if (isDeleteButtonVisible || props.isAttachmentPdf) return '1fr auto auto'; // Two buttons are displayed
  return '1fr auto'; // Only one
});


return { __sfc: true,props, areButtonsVisible, canInvoiceBeEdited, isAttachmentRequestRunning, emit, canViewAttachment, onClickOfField, templateColumns, EditIcon }
}

})